import React from 'react'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import { CustomButtom } from '../../../../components/BotaoCTA/styles'
import { eventTrack } from 'src/components/GoogleTagManager';
import { slugfy } from 'src/utils/formatters';

import * as S from './style'

export default function TagVeloe() {
	const scrollToOffer = () => {
		const el = document.querySelector('#plans')
		const yOffset = -80
		const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset

		window.scrollTo({ top: y, behavior: 'smooth' })
	}

	const { data, isLoading } = useFetchContent()
	const {
		titulo,
		titleColor,
		corDoBotao,
		corDoTextoDoBoto,
		botao,
		tag
	} = getSection({
		sectionName: 'landingSecaoTagVeloe',
		data
	})

	const { file, title } = tag.fields

	if (isLoading || !data) return <Loading />
	return (
    <S.Container>
      <S.Title color={titleColor}>{titulo}</S.Title>
      <S.Image src={`https://${file.url}`} alt={title} />
    </S.Container>
  );
}
